import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


// Importing translation files

import translationEN from "./English.json";
import translationPR from "./Portuguese.json";

const resources = {

  en: {
    translation: translationEN,
  },
  pt: {
    translation: translationPR,
  },
};
//i18N Initialization

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem("lang"),
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });
